<template>
  <v-card class="p-4">
    <v-card-title>
      Les vidéos
      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher (Nom, Outil, Thème)"
        single-line
        hide-details
      ></v-text-field>

      <v-spacer></v-spacer>
      <template>
        <v-btn class="mx-2" small fab :loading="loading" :disabled="loading" @click="exportCSV"  data-toggle="tooltip" title="Export des données au format csv">
          <v-icon dark small>
            mdi-database-export
          </v-icon>
        </v-btn>
      </template>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredVideos"
      :server-items-length="totalItems"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      @page-count="pageCountChange"
      hide-default-footer
    >
      <template v-slot:item.title="{ item }">
        <div style="display: flex; align-items: center;">
          <v-avatar size="20" color="pink" class="mr-3">
            <v-icon color="white" size="10">mdi-play</v-icon>
          </v-avatar>
          <span>{{ item.title }}</span>
        </div>
      </template>

      <template v-slot:item.outil="{ item }">
        <span>{{ item.outil ? item.outil : item.theme_title }}</span>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      color="#e6057d"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>

<script>
import Api from "@/core/services/api.service";

export default {
  name: "videos",
  data() {
    return {
      loading: true,
      search: "",
      headers: [
        { text: "Nom", value: "title", align: "start" },
        { text: "Outil", value: "outil", align: "start" },
        { text: "Thème", value: "theme_title", align: "start" },
        { text: "Nombre de vues pour votre organisation", value: "views", align: "center" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      totalItems: 0,
      videos: [],
    };
  },

  computed: {
    filteredVideos() {
      if (!this.search) return this.videos;
      const lowerSearch = this.search.toLowerCase();

      return this.videos.filter(video =>
        Object.keys(video).some(key => {
          if (key === "views") return false;
          return String(video[key] || "").toLowerCase().includes(lowerSearch);
        })
      );
    },
  },

  methods: {
    getAllVideos() {
      this.loading = true;
      Api.post("cockpit-videos")
        .then((response) => {
          if (response.data.status === "success") {
            this.videos = response.data.data;
            this.totalItems = response.data.total;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des données:", error);
          this.loading = false;
        });
    },

    pageCountChange(pageCount) {
      this.pagination.pagesNumber = pageCount;
    },

    exportCSV() {
      const rows = [
        ["Nom", "Outil", "Thème", "Nombre de vue"],
        ...this.filteredVideos.map(v => [
          v.title,
          v.outil,
          v.theme_title,
          v.views,
        ]),
      ];

      // Transformation en CSV
      const csvContent = rows.map(e => e.map(val => `"${val}"`).join(",")).join("\n");

      // Création du blob + téléchargement
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "videos.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },

  mounted() {
    this.getAllVideos();
  },
};
</script>
